import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6243ff48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-view" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "No process", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_6 = { "data-bs-dismiss": "modal" }
const _hoisted_7 = {
  key: 0,
  class: "mb-5 ps-2 mt-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Sub processes")
], -1))
const _hoisted_9 = ["id", "onUpdate:modelValue"]
const _hoisted_10 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("select", {
        class: "form-select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.processTemplateId) = $event)),
        "aria-label": "Project Template",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tryNext && _ctx.tryNext(...args))),
        disabled: !_ctx.processTypes.length
      }, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processTypesAndSinglemodules, (template) => {
          return (_openBlock(), _createElementBlock("option", {
            key: template.typeId,
            value: template.value
          }, _toDisplayString(template.label), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_2), [
        [_vModelSelect, _ctx.processTemplateId]
      ]),
      (!_ctx.processTypes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("small", _hoisted_6, [
              _createTextVNode(" You have not created a process template until now: "),
              _createVNode(_component_router_link, {
                class: "strong",
                to: { name: 'settings-processes' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("create one")
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.subTypes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subTypes, (sub) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "",
              key: sub.processId
            }, [
              _withDirectives(_createElementVNode("input", {
                id: sub.processId,
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((_ctx.subProcesses[sub.processId]) = $event)
              }, null, 8, _hoisted_9), [
                [_vModelCheckbox, _ctx.subProcesses[sub.processId]]
              ]),
              _createElementVNode("label", {
                class: "form-label ps-2",
                for: sub.processId
              }, _toDisplayString(sub.name), 9, _hoisted_10)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}